import type { ApiService } from "@phurshell/psiapp-frontend-core/domain";
import { Endpoints } from "@phurshell/psiapp-frontend-core/infra";

export type AppointmentListPage = {
  data: any[];
  total: number;
  to: number | null;
  next_page_url: string | null;
};

/**
 * Lista paginada de sessões com a MESMA requisição do legado (GET appointments).
 * O `appointmentRepo.getAppointments` do core devolve só o `data` e perde `total`,
 * `to` e `next_page_url`, que a tela usa no contador e no "Carregar mais".
 */
export class PatientAppointmentDataSource {
  constructor(private readonly api: ApiService) {}

  async list(query: Record<string, unknown>): Promise<AppointmentListPage> {
    const res: any = await this.api.get(Endpoints.appointments, query);
    return { data: res?.data ?? [], total: res?.total ?? 0, to: res?.to ?? null, next_page_url: res?.next_page_url ?? null };
  }

  /**
   * Criar sessão (POST appointments) devolvendo a resposta inteira ({ status, data, message }), como o legado.
   * O `createAppointment` do core devolve só o `data` e busca a sessão de novo.
   */
  async create(params: Record<string, unknown>) {
    return (await this.api.post(Endpoints.appointments, params)) as any as { status: boolean; data: any; message?: string };
  }

  /** Sessão pelo id da sala do Whereby (GET whereby-guest-link/:callId). Não existe no core. */
  async getByCallId(callId: string) {
    const res: any = await this.api.get(`whereby-guest-link/${callId}`);
    return res?.data;
  }

  /** Horário avulso compartilhado pelo psi (GET shared-appointment-slots/:uuid). O core só tem o POST. */
  async getSharedSlot(uuid: string) {
    const res: any = await this.api.get(`${Endpoints.shared_appointment_slots}/${uuid}`);
    return res?.data;
  }
}
